import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import { SalesImportsService } from '@app/core/reports/services/sales-imports.service';
import { InventoryPlanningService } from '@app/core/tools/services/inventory-planning.service';

@Component({
  selector: 'cnc-rfq-details-cogs',
  templateUrl: './rfq-details-cogs.component.html',
  styleUrls: ['./rfq-details-cogs.component.scss'],
})
export class RfqDetailsCogsComponent implements OnInit {
  @Input() rfq;

  constructor() {}

  ngOnInit() {
    // console.log(this.rfq);
    // this.getCost();
  }

  getCost() {}
}
